// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"33a676b9","513":"7138a75c","787":"17881f5b"}[chunkId] + ".chunk.js";
};